'use client';

import React, { useState, JSX } from 'react';
import { Button, Card, Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import styles from './Accordion.module.scss';
import { PageProps } from '@/Util/magnolia';
import { EditableArea } from '@magnolia/react-editor';
import { MgnlContent } from '@magnolia/frontend-helpers-base';

const AccordionElement = (props: {
  accordionBody: MgnlContent;
  headerText: string;
  pageProps: PageProps;
}): JSX.Element => {
  const { accordionBody, headerText } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={styles.accordion__element}>
      <Button
        className={styles.accordion__element__button}
        onClick={(): void => setIsOpen(value => !value)}
      >
        <span>{headerText}</span>
        <FontAwesomeIcon
          className={`${styles.accordion__element__chevron} ${
            isOpen ? styles.accordion__element__chevronUp : ''
          }`}
          icon={faChevronDown}
        />
      </Button>
      <Collapse isOpen={isOpen}>
        <Card className={styles.accordion__element__card}>
          {accordionBody ? <EditableArea content={accordionBody} /> : <></>}
        </Card>
      </Collapse>
    </div>
  );
};

export default AccordionElement;
